import {
  LocationConfidenceScoresLabelEnum,
  ProjectionProviderType,
  ProviderActionStatusEnum
} from "@app/projects/enumerators";
import { NewPatientClaimsEnum } from "@app/projects/servicing-provider";

export const EMPTY_DISPLAY = "---";

export const ProviderActionStatusEnumToDisplay = (status: ProviderActionStatusEnum): string => {
  switch (status) {
    case ProviderActionStatusEnum.FullyTerminated:
      return "Terminated";
    case ProviderActionStatusEnum.PartiallyTerminated:
      return "Partially Terminated";
    case ProviderActionStatusEnum.FullyExcluded:
      return "Excluded";
    case ProviderActionStatusEnum.PartiallyExcluded:
      return "Partially Excluded";
    case ProviderActionStatusEnum.FullyTargeted:
      return "Targeted";
    case ProviderActionStatusEnum.PartiallyTargeted:
      return "Partially Targeted";
    case ProviderActionStatusEnum.Unknown:
    default:
      return "No Actions Applied";
  }
}

export const providerActionStatusEnumToProjectionProviderType = (status: ProviderActionStatusEnum): ProjectionProviderType => {
  switch (status) {
    case ProviderActionStatusEnum.FullyExcluded:
      return ProjectionProviderType.ExcludeImpact;
    case ProviderActionStatusEnum.FullyTargeted:
      return ProjectionProviderType.Target;
    default:
      return null;
  }
}

export const formatNewPatientIndicator = (value?: boolean | null): string => {
  if (value === true) return NewPatientClaimsEnum.Yes;
  if (value === false) return NewPatientClaimsEnum.No;
  return NewPatientClaimsEnum.Insufficient;
};

export const displayFraction = (numerator: number | null, denominator: number): string => {
  return !!numerator ? `${numerator}/${denominator}` : EMPTY_DISPLAY;
}

export const locationConfidenceScoreToDisplay = (score?: LocationConfidenceScoresLabelEnum | null): string => {
  switch (score) {
    case LocationConfidenceScoresLabelEnum.High:
      return "High";
    case LocationConfidenceScoresLabelEnum.Medium:
      return "Medium";
    case LocationConfidenceScoresLabelEnum.Low:
      return "Low";
    case LocationConfidenceScoresLabelEnum.VeryLow:
      return "Very Low";
    default:
      return "No Score Available";
  }
}